import { useFormContext, Controller } from 'react-hook-form';
import styles from '../index.module.scss';
import classNames from 'classnames';
import Select from '../../../../../../../Inputs/Select';
import { FormControl } from '@mui/material';
import usePayorOptions from '../../../../../../../../hooks/usePayorOptions';
import { ReactComponent as ExpandMoreIcon } from '../../../../../../../../assets/icons/patientProfileIcons/expandMoreIcon.svg';
import { SELECT_NONE_OPTION } from '../../../../../../../../utils/noneOptionUtil';

export const PayorField = () => {
  const { control } = useFormContext();
  const payorOptions = usePayorOptions();

  return (
    <FormControl
      className={classNames(
        styles.inputWrapper,
        styles.selectWrapper,
        styles.largeInputWrapper
      )}>
      <Controller
        defaultValue={SELECT_NONE_OPTION.value}
        render={({ field }) => (
          <Select
            options={payorOptions}
            label="Payor"
            {...field}
            IconComponent={ExpandMoreIcon}
            classes={{
              select: styles.inputField,
              icon: styles.selectIcon,
            }}
            className={styles.selectRoot}
            disableUnderline
            displayEmpty={true}
            renderValue={(value) => (
              <div
                className={classNames(styles.selectValue, {
                  [styles.placeholder]: !value || value === SELECT_NONE_OPTION.value,
                })}>
                {payorOptions?.find((option) => option?.value === value)
                      ?.label}
              </div>
            )}
          />
        )}
        name="payor"
        control={control}
      />
    </FormControl>
  );
};
